import { Alert } from 'antd';
import React from 'react';
import { useLoaderData } from 'react-router-dom';
import styles from './approved.module.scss';
import { RecievedFiles } from '../../template';

const ApprovedByLeoprinting = () => {
    const { artworkData } = useLoaderData()
    return (
        <div className={styles.stepBox}>
            <h3>Task for you</h3>
            <Alert message='Approved' description='Leopriting has Approved the artwork. Please Start production from your end' />
            <br />
            {artworkData.document && artworkData.document.map(({ url, name, comment }) => {
                return (<div key={url}>
                    <RecievedFiles image={url} name={name} comment={comment} k={url} />
                </div>)
            })}

        </div>
    )
}

export default ApprovedByLeoprinting;